import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import {GlobalSettingsContext} from '@iotopen/lynx-react-components';
import App from './App';

// Custom CSS to override Bootstrap's primary color
const style = document.createElement('style');
style.textContent = `
  :root {
    --bs-primary: #0D3E53;
    --bs-primary-rgb: 13, 62, 83;
  }
  
  .btn-primary {
    --bs-btn-bg: #0D3E53;
    --bs-btn-border-color: #0D3E53;
    --bs-btn-hover-bg: #0a2f3f;
    --bs-btn-hover-border-color: #092a39;
    --bs-btn-active-bg: #092a39;
    --bs-btn-active-border-color: #082533;
    --bs-btn-disabled-bg: #e9ecef;
    --bs-btn-disabled-border-color: #e9ecef;
    --bs-btn-disabled-color: #6c757d;
  }

  .btn-outline-primary {
    --bs-btn-color: #0D3E53;
    --bs-btn-border-color: #0D3E53;
    --bs-btn-hover-bg: #0D3E53;
    --bs-btn-hover-border-color: #0D3E53;
    --bs-btn-active-bg: #0D3E53;
    --bs-btn-active-border-color: #0D3E53;
  }

  .text-primary {
    color: #0D3E53 !important;
  }

  @keyframes highlightDevice {
    0% { background-color: rgba(13, 62, 83, 0.2); }
    50% { background-color: rgba(13, 62, 83, 0.1); }
    100% { background-color: transparent; }
  }

  .highlight-device {
    animation: highlightDevice 2s ease-out;
  }

  /* Fix for ResizeObserver warning */
  body {
    overflow-y: scroll;
  }

  #root {
    overflow: hidden;
    position: relative;
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <GlobalSettingsContext source={'/settings.json'}>
        <App/>
    </GlobalSettingsContext>
);
